import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { DOCTOR_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import { createDoctor, fetchSignature, updateDoctor } from "services/doctor";
import { useSelector } from "react-redux";
import { STALE_TIME } from "utils/constants";
import zoneLocalStorageId from "utils/zone";
import Loader from "components/Common/loader";

const AddDoctor = ({ onClose, rowData, handleDocuments }) => {
  console.log("Add Doctor Rendered with rowData:");
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const {
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => {
      return rowData;
    }, [rowData]),
  });
  const { showAlert } = useAlert();

  const [createdDoctorData, setCreatedDoctorData] = useState(null);

  const onSuccess = (response) => {
    const refetchDoctors = true;
    const message = rowData
      ? "Doctor Details updated successfully!"
      : "Doctor Details created successfully!";
    showAlert(message, "success");

    if (response?.data) {
      setCreatedDoctorData(response.data);
    }

    onClose(refetchDoctors, response?.data);
  };

  // const onError = (err) => {
  //   const errorDetail = err?.response?.data?.detail;
  //   const message =
  //     typeof errorDetail === "string"
  //       ? errorDetail
  //       : errorDetail?.msg || JSON.stringify(errorDetail);

  //   showAlert(message, "danger");
  // };

  const onError = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;
    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: addDoctorsMutate, isLoading: isLoadingAdd } = useMutation({
    mutationFn: createDoctor,
    onSuccess,
    onError,
  });

  const { mutate: updateDoctorMutate, isLoading: isLoadingUpdate } =
    useMutation({
      mutationFn: updateDoctor,
      onSuccess,
      onError,
    });

  const isSubmitting = isLoadingAdd || isLoadingUpdate;

  const formatDateToYyyyMmDd = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const SubmitDoctors = async (values, e) => {
    e.preventDefault();
    let payload = {
      doctor_name: values?.doctor_name,
      area_name: values?.area_name,
      clinic_name: values?.clinic_name,
      hospital_name: values?.hospital_name,
      clinic_phone: values?.clinic_phone,
      email: values?.email,
      phone_res: values?.phone_res,
      address: values?.address,
      doctor_id: parseInt(values?.doctor_id),
      doctor_degree_id: values?.doctor_degree_id,
      doctor_dob: formatDateToYyyyMmDd(values?.doctor_dob),
      doctor_marriage_anniversary: formatDateToYyyyMmDd(
        values?.doctor_marriage_anniversary
      ),
      clinic_address: values?.clinic_address,
      hospital_address: values?.hospital_address,
      hospital_phone: values?.hospital_phone,
      mobile: values?.mobile,
      remark: values?.remark,
      doctor_username: values?.doctor_username,
      password_md5: values?.password_md5,
      tagged: values?.tagged,
      discount_approved: values?.discount_approved,
      specialization_id: values?.specialization_id,
      zone_id:
        values?.zone_id?.value || values?.zone_id || zoneLocalStorageId(),
      is_active: values?.is_active,
      franchise_id: Number(localStorage.getItem("franchise_id")),
      created_by: jwtAuthreducer.user?.employee_code_id,
      doctor_type: values?.doctor_type,
      marketing_person: values?.marketing_person_id,
      ip_calculation_method: values?.ip_calculation_method,
    };

    if (values?.doctor_type === "INTERNAL") {
      const { fileName, filePath, fileData } = values;
      payload.file_name = fileName;
      payload.file_path = filePath;

      const base64Pattern = [
        "data:image/jpeg;base64,",
        "data:image/png;base64,",
      ];
      base64Pattern.forEach((pattern) => {
        if (fileData?.startsWith(pattern)) {
          payload.file_data = fileData.replace(pattern, "");
        }
      });
    }

    payload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== "" && v !== undefined)
    );
    // if (rowData) {
    //   updateDoctorMutate({
    //     id: rowData?.id,
    //     ...payload,
    //   });
    // } else {
    //   addDoctorsMutate(payload);
    // }

    const zoneIds = Array.isArray(values?.zone_id)
      ? values.zone_id
      : [values?.zone_id];

    for (const zId of zoneIds) {
      const zonePayload = { ...payload, zone_id: zId };

      if (rowData) {
        await updateDoctorMutate({
          id: rowData?.id,
          ...zonePayload,
        });
      } else {
        await addDoctorsMutate(zonePayload);
      }
    }

    reset();
  };

  const doctorId = rowData?.id;
  const { data, isLoading, isError, error, refetch } = useQuery(
    ["fetch-signature", doctorId],
    () => fetchSignature({ doctor_id: doctorId }),
    {
      staleTime: STALE_TIME,
      enabled: !!doctorId && rowData?.doctor_type !== "EXTERNAL",
    }
  );

  console.log("dat", data);

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading={true} />
        </div>
      )}
      <CustomForm
        config={DOCTOR_FORM_CONFIG(rowData)}
        onSubmit={SubmitDoctors}
        columnCount={3}
        rowData={rowData}
        handleDocuments={handleDocuments}
        signatureData={data?.data}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddDoctor;
